import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class CustomerReferenceService extends BaseReferenceService {
  constructor() {
    super('CustomerReference');
  }
  get(): Observable<IdDescription[]> {
    console.log('A customer search should be used instead of a dropdown');
    return super.get();
  }

  getOwners(): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetOwners`);
  }
}
